"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterCount = exports.TextAreaContainer = exports.StyledTextArea = exports.StyledForm = exports.Paragraph = exports.RadioWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const common_buoy_input_1 = require("@buoyhealth/common.buoy-input");
exports.RadioWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  margin: 0 -8px;

  label {
    flex-basis: 100%;
    position: relative;

    &:before {
      content: "";
      background-color: ${({ theme }) => theme.palette.gray[40]};
      height: 1px;
      flex-grow: 1;
      position: absolute;
      width: calc(100% - 7px);
      left: calc(50% + 12px);
      top: 20px;
    }

    &:first-of-type:before {
      width: calc(100% - 10px);
      left: calc(50% + 12px);
    }
  }

  label:last-of-type {
    &:before {
      content: none;
    }

    .MuiFormControlLabel-label {
      text-align: right;
      right: 0;
      padding-right: 14px;
    }
  }

  label:first-of-type {
    .MuiFormControlLabel-label {
      text-align: left;
      left: 0;
      padding-left: 14px;
    }
  }

  .MuiFormGroup-root {
    width: calc(100% + 12px);
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-left: calc(-20% + 24px);
    margin-right: calc(-20% + 24px);
  }

  .MuiFormControlLabel-label {
    ${({ theme }) => theme.typography.variants.primary.main};
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    top: 100%;
  }
`;
exports.Paragraph = styled_components_1.default.p `
  ${({ theme }) => theme.typography.variants.primary.main};
  margin: 24px 0 0;
`;
exports.StyledForm = styled_components_1.default.form `
  display: flex;
  flex-direction: column;
`;
exports.StyledTextArea = (0, styled_components_1.default)(common_buoy_input_1.TextArea) `
  .MuiOutlinedInput-root {
    padding-bottom: 30px;
  }

  textarea::placeholder {
    font-size: 14px;
  }
`;
exports.TextAreaContainer = styled_components_1.default.div `
  position: relative;
  margin: 16px 0;
`;
exports.CharacterCount = styled_components_1.default.span `
  ${({ theme }) => theme.typography.variants.primary.smaller};
  color: ${({ theme }) => theme.palette.gray[70]};
  position: absolute;
  bottom: 10px;
  right: 12px;
`;
//# sourceMappingURL=styles.js.map